import { render, staticRenderFns } from "./TerminalStampMain.vue?vue&type=template&id=5580083a&scoped=true"
import script from "./TerminalStampMain.vue?vue&type=script&lang=js"
export * from "./TerminalStampMain.vue?vue&type=script&lang=js"
import style0 from "./TerminalStampMain.vue?vue&type=style&index=0&id=5580083a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5580083a",
  null
  
)

export default component.exports